<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.87 11.25">
		<path d="M16.77,5.2A9.39,9.39,0,0,0,8.44,0,9.4,9.4,0,0,0,.1,5.2a1,1,0,0,0,0,.85,9.4,9.4,0,0,0,8.34,5.2,9.39,9.39,0,0,0,8.33-5.2A1,1,0,0,0,16.77,5.2ZM8.43.94A3.75,3.75,0,1,1,4.69,4.69,3.74,3.74,0,0,1,8.43.94Zm0,9.37A8.44,8.44,0,0,1,.94,5.62a8.57,8.57,0,0,1,3.8-3.78,4.69,4.69,0,1,0,7.39,0,8.57,8.57,0,0,1,3.8,3.78A8.44,8.44,0,0,1,8.44,10.31Z"/>
	</svg>
</template>